module.exports = __webpack_public_path__ + "media/icons/carouselArrowPrev-ae325d0b.svg";